export default __webpack_public_path__ + "static/media/WhatsApp.95a9d02c.png";